import React from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import { BaseUserProfile } from '@/api/types'
import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { birthdateToAge } from '../utils'

type Props = {
  item: BaseUserProfile
  index: number
  isReadonly?: boolean
  onRemove?: (idUnit: number) => void
}

export default function HouseholdMemberItem({ item, index, isReadonly = false, onRemove }: Props) {
  const { t } = useTranslation()

  const actLevelVal =
    item.activityLevels.length > 0
      ? item.activityLevels[item.activityLevels.length - 1].value
      : 'LOWEST'
  const actLevelLabel =
    actLevelVal !== 'AUTO'
      ? t(`profile.activityLevelOptions.${actLevelVal}` as any)
      : item.activityLevels[0].dailyBurnedEnergyKcal

  return (
    <div className="HouseholdSelector-grid">
      <span>{index + 1}</span>
      <Input disabled={true} value={item.firstName} size="small" readOnly />
      <Input
        disabled={true}
        value={birthdateToAge(item.birthDate)}
        size="small"
        type="number"
        readOnly
      />
      <Input
        value={
          item.weightLogs.length > 0 ? item.weightLogs[item.weightLogs.length - 1].weightKg : ''
        }
        size="small"
        type="number"
        readOnly
      />
      <Input
        value={
          item.heightLogs.length > 0 ? item.heightLogs[item.heightLogs.length - 1].heightCm : ''
        }
        size="small"
        type="number"
        readOnly
      />
      <Input value={t(`profile.genderOptions.${item.gender}` as any)} size="small" readOnly />
      <Input value={actLevelLabel} size="small" readOnly />

      {!isReadonly && (
        <Button variant="icon" onPress={() => onRemove?.(item.idUser)} style={{ padding: 0 }}>
          <div className="HouseholdSelector-deleteButton">
            <FontAwesomeIcon icon={faTrashAlt} color="var(--invalid-color)" size="sm" />
          </div>
        </Button>
      )}
    </div>
  )
}
